/**
 * @generated SignedSource<<153eadb687cbddcb6874f2a640cf28d0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProjectVersionFileKind = "DATA" | "PACKAGE" | "SUBMISSION_EVALUATION" | "TEMPLATE";
import { FragmentRefs } from "relay-runtime";
export type routingFragment2$data = {
  readonly kind: ProjectVersionFileKind;
  readonly " $fragmentType": "routingFragment2";
};
export type routingFragment2$key = {
  readonly " $data"?: routingFragment2$data;
  readonly " $fragmentSpreads": FragmentRefs<"routingFragment2">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "routingFragment2",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    }
  ],
  "type": "ProjectVersionFile",
  "abstractKey": null
};

(node as any).hash = "aec45f8e135e5d67848526a7a03fc5ac";

export default node;
